import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import SocialShareBlock from '../SocialShareBlock';
import contact from '../../public/images/icons/contact.png';
import { buildSocialLinks } from '../../utils/common';
import ImageTag from '../ImageTag';

const useStyles = makeStyles(theme => ({
  socialLinksBlock: {
    display: 'flex',
    flexDirection: props => (props.showContact ? 'row' : 'column'),
  },
  iconClass: {
    width: '40px !important',
    height: '40px !important',
    backgroundSize: '135px auto !important',
    [theme.breakpoints.up('md')]: {
      marginRight: 8,
      marginBottom: 8,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 5,
      marginBottom: 5,
    },
  },
  contactIcon: {
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      width: '60px',
    },
  },
  followText: {
    color: '#5f5f5f',
    fontSize: 12,
    opacity: 0.5,
    [theme.breakpoints.up('md')]: {
      paddingBottom: 10,
    },
  },
}));

const StubPageSocialLinks = ({ contacts, showContact, showContactsTab, socialLinksTitle }) => {
  const classes = useStyles({ showContact });

  const socialLinks = buildSocialLinks(contacts);

  return (
    <div className={classes.socialLinksBlock}>
      {showContact && (
        <ImageTag
          src={contact}
          alt="contact"
          title="Contact"
          className={classes.contactIcon}
          onClick={showContactsTab}
        />
      )}
      {!showContact && socialLinks?.length > 0 && <div className={classes.followText}>{socialLinksTitle}</div>}
      {contacts?.length > 0 && <SocialShareBlock socialLinks={socialLinks} className={classes.iconClass} />}
    </div>
  );
};

StubPageSocialLinks.propTypes = {
  contacts: PropTypes.array,
  showContact: PropTypes.bool,
  showContactsTab: PropTypes.func,
  socialLinksTitle: PropTypes.string,
};

export default StubPageSocialLinks;
